export default __webpack_public_path__ + "static/media/landing-page-chars-4.8a5551af.png";